export default __webpack_public_path__ + "static/media/ruth-shaffir.c90812ba.png";